/**
 * Truncate text to a max word count for table/card display.
 * Matches Companies / Deliveries / DeviceSales list pattern.
 */
export function limitWords(text, maxWords = 3) {
  if (!text) return "-";
  const words = String(text).trim().split(/\s+/).filter(Boolean);
  if (words.length <= maxWords) return words.join(" ");
  return words.slice(0, maxWords).join(" ");
}

/** @deprecated alias — prefer limitWords */
export const limitToThreeWords = (text) => limitWords(text, 3);
